import { type ReactNode } from 'react'
import { cn } from '#app/utils/misc.tsx'

interface ScrollRevealProps {
	children: ReactNode
	className?: string
	delay?: number
	component?: React.ElementType
}

export function ScrollReveal({ children, className, component = 'div', delay = 500 }: ScrollRevealProps) {
	let Component = component
	return <Component className={cn('block-appear', className)}>{children}</Component>
}
